import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import PasswordGate from './components/PasswordGate';
import UnderMaintenance from './pages/UnderMaintenance';
import Simulator from './pages/Simulator';
import DsvSimulator from './pages/DsvSimulator';
import YdmSimulator from './pages/YdmSimulator';
import IntegratedSimulator from './pages/IntegratedSimulator';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<UnderMaintenance />} />
        </Route>
        <Route path="/simulator" element={<PasswordGate><Simulator /></PasswordGate>} />
        <Route path="/dsv-simulator" element={<PasswordGate><DsvSimulator /></PasswordGate>} />
        <Route path="/ydm-simulator" element={<PasswordGate><YdmSimulator /></PasswordGate>} />
        <Route path="/integrated" element={<PasswordGate><IntegratedSimulator /></PasswordGate>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
